import { ICoreState } from './core.types';

const CoreInitialState = (): ICoreState => ({});

export default CoreInitialState;
